export const actionTypes = {
    setDraftYear: 'OPTIONS_SET_DRAFT_YEAR',
    setRankings: 'OPTIONS_SET_RANKINGS',
    setNumberOfRounds: 'OPTIONS_SET_ROUNDS',
    setDraftSpeed: 'OPTIONS_SET_SPEED',

    selectTeam: 'OPTIONS_TEAM_SELECT',
    deselectTeam: 'OPTIONS_TEAM_DESELECT',
    selectAllTeams: 'OPTIONS_TEAM_SELECT_ALL',
    deselectAllTeams: 'OPTIONS_TEAM_DESELECT_ALL',
}

export const roConsensus = 'Consensus';
export const rnConsensus = 'RANK';
export const rnFC = 'RANK';

export const setDraftYear = (year) => ({ type: actionTypes.setDraftYear, year });
export const setRankings = (ranking) => ({ type: actionTypes.setRankings, ranking });
export const setNumberOfRounds = (rounds) => ({ type: actionTypes.setNumberOfRounds, rounds });
export const setDraftSpeed = (speed) => ({ type: actionTypes.setDraftSpeed, speed });

export const selectTeam = (code) => ({ type: actionTypes.selectTeam, code });
export const deselectTeam = (code) => ({ type: actionTypes.deselectTeam, code });
export const selectAll = (codes) => ({ type: actionTypes.selectAllTeams, codes });
export const deselectAll = () => ({ type: actionTypes.deselectAllTeams });